import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Select, MenuItem, FormControl, InputLabel,
  Typography, Box, Paper
} from "@mui/material";
import { putData } from "../../BaseUrl";

const GRADES = [
  "MunMazhalai", "Mazhalai",
  "Nilai 1", "Nilai 2", "Nilai 3", "Nilai 4",
  "Nilai 5", "Nilai 6", "Nilai 7", "Nilai 8"
];

const AdmissionDialog = ({ open, onClose, application, onSuccess }) => {
  const [assignedGrade, setAssignedGrade] = useState(application?.gradeApplyingFor || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [admissionResult, setAdmissionResult] = useState(null);

  const handleSubmit = async () => {
    if (!assignedGrade) {
      setError("Please select a grade");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const result = await putData(`admin/admission/applications/${application.id}/admit`, {
        assignedGrade
      });
      if (result?.data) {
        setAdmissionResult(result.data);
      }
    } catch (err) {
      setError(err?.message || "Admission failed");
    }
    setLoading(false);
  };

  const handleClose = () => {
    if (admissionResult) {
      onSuccess("Student admitted successfully");
    }
    setAdmissionResult(null);
    setError("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>
        Admit: {application?.firstName} {application?.lastName}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Application #{application?.applicationNumber}
        </Typography>

        {admissionResult ? (
          <Paper sx={{ p: 3, textAlign: "center", backgroundColor: "#e8f5e9", borderRadius: 2 }}>
            <Typography variant="h6" color="#2e7d32" fontWeight="bold" gutterBottom>
              Admission Confirmed!
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={1}>Registration Number</Typography>
            <Typography variant="h4" fontWeight="bold" color="#1a237e">
              {admissionResult.registrationNumber}
            </Typography>
            <Typography variant="body2" color="text.secondary" mt={1}>
              Grade: {admissionResult.assignedGrade}
            </Typography>
            <Typography variant="caption" color="text.secondary" mt={2} display="block">
              Login credentials have been sent to the parent email addresses.
            </Typography>
          </Paper>
        ) : (
          <Box>
            <FormControl fullWidth size="small">
              <InputLabel>Assign Grade *</InputLabel>
              <Select value={assignedGrade} label="Assign Grade *"
                onChange={(e) => setAssignedGrade(e.target.value)}>
                {GRADES.map(g => <MenuItem key={g} value={g}>{g}</MenuItem>)}
              </Select>
            </FormControl>
            {error && <Typography color="error" variant="body2" mt={2}>{error}</Typography>}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {admissionResult ? (
          <Button onClick={handleClose} variant="contained"
            sx={{ background: "linear-gradient(90deg, #4A7BA8, #244C77)" }}>
            Done
          </Button>
        ) : (
          <>
            <Button onClick={handleClose} variant="outlined" color="inherit">Cancel</Button>
            <Button onClick={handleSubmit} variant="contained" disabled={loading}
              sx={{ background: "linear-gradient(90deg, #4caf50, #2e7d32)" }}>
              {loading ? "Processing..." : "Confirm Admission"}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AdmissionDialog;
